interface FileDefaultProps {
  className?: string;
  size?: number;
}

export const FileDefault = ({
  className = '',
  size = 40,
}: FileDefaultProps) => {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox='0 0 40 40'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      {/* Document base */}
      <path
        d='M9 0h16l6 6v30a4 4 0 01-4 4H9a4 4 0 01-4-4V4a4 4 0 014-4z'
        fill='#F2F4F7'
      />
      {/* Folded corner */}
      <path d='M25 0l6 6h-6V0z' fill='#D0D5DD' />
      {/* Generic file icon in center */}
      <g transform='translate(15, 16)'>
        <path
          d='M3 1.5v9M3 1.5L5.5 4M3 1.5L.5 4'
          stroke='#98A2B3'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
          fill='none'
        />
      </g>
    </svg>
  );
};
